export default "/assets/images/chart-04.aed722597bc5dd65.svg";